// tslint:disable:max-classes-per-file

import { Action } from '@ngrx/store';

import { Shift } from '../../models/shift';

export const DELETE_SHIFT = '[Shift] delete shift';
export const DELETE_SHIFT_SUCCESS = '[Shift] delete shift success';
export const DELETE_SHIFT_FAIL = '[Shift] delete shift fail';

export class DeleteShift implements Action {
  public readonly type = DELETE_SHIFT;

  constructor(public payload: { shiftToDelete: Shift; shifts: Array<Shift> }) {}
}

export class DeleteShiftSuccess implements Action {
  public readonly type = DELETE_SHIFT_SUCCESS;

  constructor(public payload: Array<Shift>) {}
}

export class DeleteShiftFail implements Action {
  public readonly type = DELETE_SHIFT_FAIL;

  constructor(public payload: any = null) {}
}

export type ShiftSettingsDeleteActions =
  | DeleteShift
  | DeleteShiftSuccess
  | DeleteShiftFail;
